/*
 * RISK-ICON.TSX
 * Display the right icon for risk type
 */

import { RiskType } from "../model/physical-risk.types"
import { faHeart, faTriangleExclamation, faInfo } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface Props {
  riskType: RiskType
}

export default function RiskIcon(props: Props) {
  function getIcon() {
    switch (props.riskType) {
      case "phy":
        return faTriangleExclamation
      case "psy":
        return faHeart
      default:
        return faInfo
    }
  }

  return (
    <div className="flex my-auto">
      <FontAwesomeIcon icon={getIcon()} />
    </div>
  )
}
